import { useField } from 'formik';

import { type CrmAutoCompleteOption } from '~/common/types';

import SelectCRMJoy, { type SelectCRMJoyProps } from '../select/crm/SelectCRMJoy';

type CallbackProps =
  | {
      callback?: (value: CrmAutoCompleteOption | null) => void;
      multiple?: false;
    }
  | {
      callback?: (value: CrmAutoCompleteOption[] | null) => void;
      multiple: true;
    };

type Props = Omit<SelectCRMJoyProps, 'error' | 'multiple' | 'onChange' | 'value'> &
  CallbackProps & {
    name: string;
  };

const FormikCrmSelectorJoy: React.FC<Props> = ({ name, ...rest }) => {
  const [field, meta, helpers] = useField<CrmAutoCompleteOption | CrmAutoCompleteOption[] | null>(
    name,
  );

  const { callback, multiple, ...selectProps } = rest;

  const valueProps = multiple
    ? ({
        multiple: true,
        onChange: (options: CrmAutoCompleteOption[]) => {
          helpers.setValue(options);
          callback?.(options);
        },
        value: field.value as CrmAutoCompleteOption[],
      } as const)
    : ({
        multiple: false,
        onChange: (option: CrmAutoCompleteOption | null) => {
          helpers.setValue(option);
          callback?.(option);
        },
        value: field.value as CrmAutoCompleteOption | null,
      } as const);

  return (
    <SelectCRMJoy
      {...selectProps}
      {...valueProps}
      name={name}
      error={meta.touched ? meta.error : undefined}
      onBlur={field.onBlur}
    />
  );
};

export default FormikCrmSelectorJoy;
